export default "__VITE_ASSET__X8zez8zL__"